import { Component, OnInit, OnDestroy } from "@angular/core";
import { NgForm } from "@angular/forms";
import { Router, ActivatedRoute } from "@angular/router";

import swal from "bootstrap-sweetalert";
import * as _ from 'lodash';

import { ServiceObject } from "app/models/serviceObject";
import { CallService } from "app/services/call.service";
import { ProblemTemplateService } from "app/services/problemTemplate.service";
import { CallOutputDTO } from "app/dto/callOutputDTO";
import { Ng2selectObject } from "app/dto/ng2selectObject";
import { ServiceObjectService } from "app/services/serviceObject.service";

@Component({
    selector: 'call-create',
    templateUrl: './call-create.component.html',
    styleUrls: ['./call-create.component.scss']
})
export class CallCreateComponent implements OnInit, OnDestroy {

    private _lock: Boolean;

    constructor(
        private problemTemplatesService: ProblemTemplateService,
        private callService: CallService,
        private serviceObjectService: ServiceObjectService,
        private activatedRoute: ActivatedRoute,
        private router: Router
    ) { }

    ngOnInit() {
        this.loadData();
    }

    private errorState: CallCreateComponent.ErrorState = CallCreateComponent.ErrorState.None;


    private loadData(): void {
        this.errorState = CallCreateComponent.ErrorState.None;

        this.activatedRoute.queryParams.subscribe(params => {
          var serviceObjectId = params['serviceObjectId'];
          if (!serviceObjectId)
            this.router.navigateByUrl('/pagenotfound');

          this.serviceObjectService.getServiceObjectDetails(serviceObjectId)
              .subscribe(serviceObject => {
                  this.serviceObject = serviceObject;
                  this.call.serviceObjectId = serviceObject.id;
              }, error => {
                  if (error.status == 403 || error.status == 404) {
                      this.errorState = CallCreateComponent.ErrorState.NoData;
                  } else {
                      this.errorState = CallCreateComponent.ErrorState.UnknownError;
                      swal({
                          title: 'Ошибка',
                          text: 'Не удалось получить данные объекта обслуживания. Попробуйте снова',
                          type: 'error',
                          confirmButtonText: 'Попробовать еще раз'
                      }, () => {
                          this.loadData();
                      });
                  }
              });
        });

        this.problemTemplatesService.getProblemTemplates()
            .subscribe(problemTemplates => {
                this.problemTemplateSelectItems = _.map(problemTemplates, function(obj) { return new Ng2selectObject(obj.id.toString(), obj.name) });
            }, err => {
                this.errorState = CallCreateComponent.ErrorState.UnknownError;
                swal({
                    title: 'Ошибка',
                    text: 'Не удалось получить типовые проблемы. Попробуйте снова',
                    type: 'error',
                    confirmButtonText: 'Попробовать еще раз'
                }, () => {
                    this.loadData();
                });
            });
    }

    private ErrorStateEnum = CallCreateComponent.ErrorState;

    ngOnDestroy(): void {
        swal.close();
    }

    onSubmit(callForm: NgForm) {
        if (callForm.valid || !this._lock) {
            this._lock = true;

            this.callService.createCall(this.call).subscribe(call => {
                swal({
                    title: 'Ок',
                    text: 'Ваше обращение успешно создано',
                    type: 'success'
                }, () => {
                    this._lock = false;
                    this.router.navigate(['/call/' + call.id]);
                });
            }, err => {
                swal({
                    title: 'Ошибка сохранения',
                    text: 'При сохранении данных произошла ошибка',
                    type: 'error'
                }, () => {
                    this._lock = false;
                });
            });
        }
    }

    private problemTemplateSelectItems: Ng2selectObject[];

    private serviceObject: ServiceObject;
    private call: CallOutputDTO = new CallOutputDTO();
}


export namespace CallCreateComponent {

    export enum ErrorState {
        /**
            * Нет ошибок
            */
        None,
        /**
         * Сервер не может предоставить данные по объекту обслуживания (его не существует или доступ к данным запрещен)
         */
        NoData,
        /**
         * Другая ошибка
         */
        UnknownError
    }
}



// WEBPACK FOOTER //
// /app/SPA/src/app/client/call/create/call-create.component.ts